<!--
 * @Author: your name
 * @Date: 2021-09-01 11:58:39
 * @LastEditTime: 2022-10-28 16:10:42
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\components\BjSelectInstancesService\index.vue
-->
<template>
  <ScrollSelect
    ref="ScrollSelect"
    v-model="id"
    :api="api"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    :size="size"
    :default-params="{ lovCode: code }"
    :default-options="defaultOptions"
    :remote="remote"
    :no-data-text="noDataText"
    search-key="service"
    option-label="service"
    option-value="instanceId"
    res-key="content"
    @change="onChange"
  />
</template>
<script>
import { commonApi } from '@/api';
export default {
  name: 'BjSelectInstancesService',
  props: {
    // 默认添加的选项，可用于回写数据
    defaultOptions: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    // // 默认传参
    code: {
      type: String,
      default: null,
    },
    // defaultParams: {
    //   type: Object,
    //   default() {
    //     return {};
    //   },
    // },
    value: {
      type: [String, Number, Array],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    size: {
      type: String,
      default: 'mini',
    },
    remote: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    noDataText: {
      type: String,
      default: '无数据',
    },
  },
  data() {
    return {
      api: commonApi.getInstancesService,
      id: null,
    };
  },
  watch: {
    value: {
      handler(v, o) {
        if (!this.$isSameArrayStringify(v, o)) {
          this.id = v;
        }
      },
      immediate: true,
    },
    id(v) {
      this.$emit('input', v);
      const ITEM = this.$refs.ScrollSelect.list.find(e => e['instanceId'] === v);
      this.$emit('change', v, ITEM);
    },
  },
  mounted() {},
  methods: {
    onChange(v, item) {},
  },
};
</script>
